// src/slices/Animal/thunk.js
import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

export const addAnimal = createAsyncThunk("animal/addAnimal", async (data, { rejectWithValue }) => {
  try {
    const authUser = JSON.parse(sessionStorage.getItem("authUser"));
    const token = authUser?.data?.token?.replace("Bearer ", "");

    const response = await axios.post(`${API_URL}animal`, data, { headers: { token } });

    return response.data;
  } catch (error) {
    return rejectWithValue(error.response?.data || error.message);
  }
});

export const getAnimals = createAsyncThunk("animal/getAnimals", async ({ identifier } = {}, { rejectWithValue }) => {
  try {
    const authUser = JSON.parse(sessionStorage.getItem("authUser"));
    const token = authUser?.data?.token?.replace("Bearer ", "");

    const response = await axios.get(`${API_URL}/animal/all${identifier ? `?identifier=${identifier}` : ""}`, { headers: { token } });

    return response.data?.data;
  } catch (error) {
    return rejectWithValue(error.response?.data || error.message);
  }
});

export const getAnimalBySlug = createAsyncThunk("animal/getAnimalBySlug", async (slug, { rejectWithValue }) => {
  try {
    const authUser = JSON.parse(sessionStorage.getItem("authUser"));
    const token = authUser?.data?.token?.replace("Bearer ", "");

    const response = await axios.get(`${API_URL}/animal/one?identifier=${slug}`, { headers: { token } });

    return response.data?.data;
  } catch (error) {
    return rejectWithValue(error.response?.data || error.message);
  }
});
